import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { map, Observable } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { UserRegisterFormComponent } from '../../components/user-register-form/user-register-form.component';
import { UserVerifyEmailFormComponent } from '../../components/user-verify-email-form/user-verify-email-form.component';

@Component({
  selector: 'app-user-register',
  standalone: true,
  imports: [UserRegisterFormComponent, AsyncPipe, UserVerifyEmailFormComponent],
  templateUrl: './user-register.component.html',
  styleUrl: './user-register.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UserRegisterComponent {
  token$: Observable<Nullable<string>> = this.activatedRoute.queryParams.pipe(
    map(params => params.token),
  );

  constructor(private readonly activatedRoute: ActivatedRoute) {}
}
